type Props = {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  style?: React.CSSProperties;
};

export function Skeleton({ width = '100%', height = 16, borderRadius = 'var(--radius-md)', style }: Props) {
  return (
    <span
      aria-hidden
      style={{
        display: 'block',
        width,
        height,
        borderRadius,
        background: 'linear-gradient(90deg, var(--warm-gray-100) 25%, var(--warm-gray-50) 50%, var(--warm-gray-100) 75%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 1.4s ease infinite',
        ...style,
      }}
    />
  );
}
